import React, { useEffect } from 'react';
import { List } from '@mui/material';
import NewsItem from './NewsItem';
import { useLocation } from 'react-router-dom';

const News = ({ items, pageNum }) => {
  //   console.log('News', items);
  const location = useLocation();
  // весь хеш, включая #
  // const hash = location.hash; // "#section1"
  // const anchor = location.hash.substring(1); // "section1"
  // с проверкой
  const safeAnchor = location.hash ? location.hash.slice(1) : '';

  useEffect(() => {
    if (location.hash) {
      const hashId = location.hash.slice(1); // "696e0a902005244f099cc565"

      setTimeout(() => {
        // вместо '#id' используй [id='value']
        const element = document.querySelector(`[id='${hashId}']`);
        element?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }
  }, [location.hash]);

  return (
    <List
      // component='nav'
      sx={{ m: 0, p: 0 }}
      aria-label='main mailbox folders'
    >
      {items?.map((item) => (
        <NewsItem
          selected={safeAnchor === item._id}
          pageNum={pageNum}
          key={item._id}
          item={item}
          // stages={stages}
          // isAdmin={isAdmin}
        />
      ))}
    </List>
  );
};

export default News;
